/* Measure the existing sticky header; resizing or editor changes update the layout. */
(() => {
  if (window.viuearthLayoutLoaded) return;
  window.viuearthLayoutLoaded = true;
  let group;
  const update = () => {
    if (!group) return;
    const height = getComputedStyle(group).display === 'contents'
      ? [...group.children].reduce((sum, child) => sum + child.getBoundingClientRect().height, 0)
      : group.getBoundingClientRect().height;
    document.documentElement.style.setProperty('--ve-header-height', `${Math.ceil(height)}px`);
  };
  const observer = 'ResizeObserver' in window ? new ResizeObserver(update) : null;
  const connect = () => {
    observer?.disconnect();
    group = document.querySelector('#header-group');
    if (group) {
      observer?.observe(group);
      [...group.children].forEach(child => observer?.observe(child));
    }
    update();
  };
  connect();
  window.addEventListener('resize', update, {passive:true});
  ['shopify:section:load','shopify:section:unload','shopify:section:reorder'].forEach(event => document.addEventListener(event, connect));
})();
